import { render, staticRenderFns } from "./ClaimDocs.vue?vue&type=template&id=294a0049&scoped=true"
import script from "./ClaimDocs.vue?vue&type=script&lang=js"
export * from "./ClaimDocs.vue?vue&type=script&lang=js"
import style0 from "./ClaimDocs.vue?vue&type=style&index=0&id=294a0049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a0049",
  null
  
)

export default component.exports